import { useIntl } from 'react-intl'
import type { NextPage } from 'next'
import {
  IconPlus,
  Page,
  PageContent,
  PageHeader,
  PageHeaderActions,
  PageHeaderButton,
  PageHeaderTitle,
  PageHeaderTop,
} from '@vtex/admin-ui'
import { useNavigation } from '@vtex/raccoon-next'
import { ProductsListing } from '@/components/products-listing'

const AllProducts: NextPage = () => {
  const { formatMessage } = useIntl()
  const { navigate } = useNavigation()

  const handleNavigate = () => navigate(`/product`)

  return (
    <Page>
      <PageHeader>
        <PageHeaderTop>
          <PageHeaderTitle>
            {formatMessage({
              id: 'admin/admin.catalog.title',
              defaultMessage: 'Products and SKUs',
            })}
          </PageHeaderTitle>
          <PageHeaderActions>
            <PageHeaderButton icon={<IconPlus />} onClick={handleNavigate}>
              {formatMessage({
                id: 'admin/admin.catalog.add-product',
                defaultMessage: 'Add Product',
              })}
            </PageHeaderButton>
          </PageHeaderActions>
        </PageHeaderTop>
      </PageHeader>
      <PageContent layout="wide">
        <ProductsListing />
      </PageContent>
    </Page>
  )
}

export default AllProducts
